<template>
  <v-row class="mx-auto">
    <v-col cols="12">
      <v-card outlined :loadingComponent="loadingComponent" :disabled="loadingComponent">
        <v-card-title class="subtitle-1">{{ labelField }}</v-card-title>
        <v-card-text v-if="!readonly">
          <v-btn color="primary" @click="clickAddNew()"
          >Adicionar</v-btn
          >
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      v-for="(person, index) in dataComponent"
      :key="index"
      sm="12"
      md="6"
      lg="6"
    >
      <v-card class="mx-auto">
        <v-card-title class="primary white--text">
          <div class="headerClass"> Card {{index + 1}}  </div>
          <v-spacer></v-spacer>
          <v-btn v-if="!readonly" icon @click="closeCard(index)" class="mx-3 mt-2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" v-if="!loadingComponent">
              <PersonField
                :label="'De'"
                :rules="personRules"
                :selectedPerson="person.from"
                :readonly="readonly"
                @save="updateValues($event, index, 'from')"
              ></PersonField>

              <PersonField
                :label="'Para'"
                :rules="personRules"
                :selectedPerson="person.to"
                :readonly="readonly"
                @save="updateValues($event, index, 'to')"
              ></PersonField>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import isEmpty from "lodash/isEmpty";
import PersonField from "../fields/PersonField.vue";

export default {
  components: { PersonField },
  props: {
    index: {},
    groupUser: {},
    field: {},
    uniqueKeyStorage: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    },
    labelField: {
      type: String,
      default: "Transferência Linhas/Aparelhos Pessoa"
    },
    selectedItems: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingComponent: true,
      maxLength: 50,
      personRules: [v => (v && Object.keys(v).length > 0) || 'Obrigatório'],
      dataComponent: [
        {
          from: {},
          to: {},
        },
      ]
    };
  },
  async mounted() {
    try {
      if (this.page === 'validate') {
        this.$emit('componentLoading', true);
      }

      if (this.page === 'interaction') {
        this.readonly = true;
      }

      if (this.page === 'wizard') {
        const dataLocalStorage = await this.loadDataLocalStorage(this.uniqueKeyStorage);
        if (!isEmpty(dataLocalStorage) && this.page === 'wizard') {
          this.resultStorage = dataLocalStorage;
          this.dataComponent = Object.assign([], this.resultStorage);
        }
      }

      if (!isEmpty(this.selectedItems)) {
        this.dataComponent = Object.assign([], this.selectedItems);
      } else if (!isEmpty(this.field.values)) {
        this.dataComponent = Object.assign([], this.field.values);
      }

      this.loadingComponent = false;
      if (this.page === 'validate' || this.page === 'interaction') {
        await this.setPayload();
        this.$emit('componentLoading', false);
      }
    } finally {
      if (this.page === 'validate') {
        this.$emit('fieldReady');
      }
    }
  },
  computed: {
    ...mapState("forms", ["wizard"]),
    ...mapState("solicitation", ["solicitation_validate_values"])
  },
  methods: {
    ...mapActions("solicitation", ["loadDataLocalStorage","setAutomationComponentValues"]),
    ...mapActions("interaction", ['setAutomationComponentFields']),
    ...mapMutations("forms", ["SET_FORM_EMAIL"]),
    ...mapMutations({
      setModel: "forms/setModelDefault"
    }),
    async clickAddNew() {
      if (this.dataComponent.length >= this.maxLength) {
        await this.$swal("Limite máximo atingido", 'O número máximo de cards dessa solicitação é '+this.maxLength+'.', "info");
      } else {
        this.dataComponent = [{ from: {}, to: {} }, ...this.dataComponent ];
      }
    },
    async checkSelected(value, index) {
      const exists = this.dataComponent.some((val, i) => val['from'].id_pessoa && val['from'].id_pessoa === value.id_pessoa && i !== index);
      if (exists) {
        await this.$swal("Pessoa já selecionada!", "", "warning");
        return {};
      }
      return value;
    },
    async updateValues(value, index, field) {
      if (this.readonly) return true;

      let data = value;
      if (field === "from") {
        data = await this.checkSelected(value, index);
      }

      this.dataComponent[index][field] = data;
      await this.setPayload();
    },
    async setPayload() {
      if (this.page === 'wizard') {
        const payload = {
          step: this.index,
          selected: this.dataComponent
        };
        this.setModel(payload);
        localStorage.setItem(this.uniqueKeyStorage, JSON.stringify(this.dataComponent));
      } else if (this.page === 'interaction') {
        await this.setAutomationComponentFields({
          automation: "transfer_person_lines",
          data: this.dataComponent
        });
      } else {
        this.setAutomationComponentValues({
          automation: "transfer_person_lines",
          data: { transfer_person_lines: this.dataComponent }
        });
        this.SET_FORM_EMAIL({});
        this.SET_FORM_EMAIL(this.solicitation_validate_values);
      }
    },
    closeCard(index) {
      if (this.page === 'interaction') {
        return true;
      }
      if (index > -1) {
        this.dataComponent.splice(index, 1);
      }
      this.setPayload();
    },
  }
};
</script>
<style scoped>
.headerClass {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
